import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { KanbanBoard } from '@/components/kanban/KanbanBoard';
import { useAppStore } from '@/store/appStore';
import type { GroupBy } from '@/types';

export function KanbanPage() {
  const { groupBy } = useParams<{ groupBy: GroupBy }>();
  const setGroupBy = useAppStore(s => s.setGroupBy);

  useEffect(() => {
    if (groupBy === 'status' || groupBy === 'assignee' || groupBy === 'project') {
      setGroupBy(groupBy);
    }
  }, [groupBy, setGroupBy]);

  return <KanbanBoard />;
}
